import axios from "axios";

export function assignCuponCode(cedula, recetaUuid) {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/cupon/assign", {
                cedula: cedula,
                receta_uuid: recetaUuid
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => reject(error));
    });
}

export function useCuponCode(recetaUuid) {
    return new Promise((resolve, reject) => {
        axios
            .post("/api/cupon/use", {
                receta_uuid: recetaUuid
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => reject(error));
    });
}
